// extracted by mini-css-extract-plugin
export default {"button":"Button_button__W3WXB","typeOne":"Button_typeOne__Stkj7","typeTwo":"Button_typeTwo__MUlzB","typeThree":"Button_typeThree__fZlKM","typeFour":"Button_typeFour__xYQ-Y"};